import React from "react";
import { MountainIcon } from "lucide-react";
export function Logo({
  small = false,
  tone = "dark"
}: {
  small?: boolean;
  tone?: "dark" | "light";
}) {
  return <div className="flex flex-col items-center" data-id="element-160" data-mp="8uwep8vroj2j">
      <MountainIcon className={`text-brand ${small ? "h-7 w-7" : "h-12 w-12"}`} aria-hidden="true" data-id="element-161" data-mp="3qame18pt3z6q" />
      <span className={`font-heading font-extrabold uppercase tracking-tight ${small ? "mt-1 text-lg" : "mt-1 text-3xl md:text-4xl"}`} data-id="element-162" data-mp="3v9piaqxyq1dn">
        <span className={tone === "dark" ? "text-ink" : "text-white"} data-id="element-163" data-mp="mqrq6tnu6rvw">Woodworking </span>
        <span className="text-brand" data-id="element-164" data-mp="rr606h900bwk">Ready</span>
        <sup className={`ml-0.5 text-[0.4em] ${tone === "dark" ? "text-ink" : "text-white"}`} data-id="element-165" data-mp="dspi5u5oqyz4">™</sup>
      </span>
    </div>;
}